export default __webpack_public_path__ + "static/media/vire2.07825b44.jpg";